import withOauthRouteHandling from '../../../decorators/auth/withOauthRouteHandling';
import {
  AUTHORIZE_PATH,
  AUTHORIZE_CONFIRM_PATH,
} from '../../../constants/paths';
import OauthConfirmationLoader from './OauthConfirmationLoader';

export default withOauthRouteHandling(
  OauthConfirmationLoader,
  AUTHORIZE_PATH,
  AUTHORIZE_CONFIRM_PATH,
);
